import { createCategoryLandingDefaultFormFields } from './formFields'
import { getCategoryLandingHeroImage } from './heroImages'
import { getCategoryLabel } from './categories'
import { buildDefaultSurveyCustomFields } from './defaultSurveyFields'
import { leadGenFullbleedTemplateStyleForCategory } from './leadGenFullbleedKeys'

function getProductTemplate1Sections(category) {
  const label = getCategoryLabel(category)
  const variantMap = {
    PRODUCT_AUTO: [
      {
        type: 'text',
        title: '자동차보험, 이런 운전자에게 중요합니다',
        content: '첫 가입, 갱신 시점, 운행 패턴 변화, 가족 운전자 추가 등 상황에 따라 확인해야 할 보장 포인트가 달라질 수 있습니다.',
      },
      {
        type: 'benefit-cards',
        title: '핵심 보장 포인트',
        items: [
          { icon: '🚗', title: '대인/대물 보장', description: '가장 먼저 살펴봐야 하는 기본 구조입니다.' },
          { icon: '🛠️', title: '자차/긴급출동', description: '실제 체감도가 높은 영역을 함께 봅니다.' },
          { icon: '📋', title: '운전자 상황 반영', description: '차종과 운행 습관에 따라 방향이 달라질 수 있습니다.' },
        ],
      },
    ],
    PRODUCT_COMPREHENSIVE: [
      {
        type: 'text',
        title: '종합보험을 볼 때 중요한 기준',
        content: '보장이 많다고 좋은 것이 아니라, 현재 생활에 필요한 보장이 중심에 있는지 먼저 확인하는 것이 중요합니다.',
      },
      {
        type: 'benefit-cards',
        title: '주요 안내 포인트',
        items: [
          { icon: '🧩', title: '보장 구조 파악', description: '여러 특약을 목적별로 구분해 정리합니다.' },
          { icon: '🛡️', title: '필요한 보장만', description: '지금 생활에 꼭 맞는 보장부터 짚어 드립니다.' },
          { icon: '💬', title: '1:1 상담', description: '궁금한 점을 물어보고 바로 이어서 상담하실 수 있습니다.' },
        ],
      },
    ],
    PRODUCT_PENSION: [
      {
        type: 'stats',
        title: '연금보험 상담에서 먼저 보는 것',
        items: [
          { label: '준비 목적', value: '노후 중심' },
          { label: '중요 기준', value: '수령 구조' },
          { label: '검토 방식', value: '장기 관점' },
          { label: '상담 형태', value: '1:1' },
        ],
      },
      {
        type: 'text',
        title: '연금보험은 장기 목적이 먼저입니다',
        content: '무조건 높은 수익보다, 나에게 맞는 납입 구조와 수령 시점을 이해하는 것이 더 중요할 수 있습니다.',
      },
    ],
    PRODUCT_WHOLE_LIFE: [
      {
        type: 'text',
        title: '종신보험은 목적이 분명해야 합니다',
        content: '가족 보호, 사망 보장, 장기 유지 가능성 등 목적을 먼저 정리한 뒤 검토해야 불필요한 오해를 줄일 수 있습니다.',
      },
      {
        type: 'benefit-cards',
        title: '핵심 체크 포인트',
        items: [
          { icon: '👨‍👩‍👧', title: '가족 보호 목적', description: '누구를 위해, 어느 정도까지 준비할지 함께 정합니다.' },
          { icon: '📌', title: '필요한 보장 규모', description: '소득과 부채를 감안해 현실적인 수준을 제안합니다.' },
          { icon: '📉', title: '오래 유지할 수 있는지', description: '납입 부담까지 보며 장기 관점에서 봅니다.' },
        ],
      },
    ],
    PRODUCT_CARE: [
      {
        type: 'text',
        title: '간병보험은 미래의 돌봄 부담을 보는 보험입니다',
        content: '치료비만이 아니라 장기 간병으로 이어질 때의 생활비, 돌봄 비용, 가족 부담까지 함께 생각해야 합니다.',
      },
      {
        type: 'benefit-cards',
        title: '많이 보는 포인트',
        items: [
          { icon: '🛏️', title: '장기 간병 대비', description: '치료 이후 생활비·돌봄 비용까지 함께 짚습니다.' },
          { icon: '👨‍👩‍👧', title: '가족의 부담', description: '간병 공백과 경제적 부담을 덜 수 있는지 살펴봅니다.' },
          { icon: '📋', title: '확인할 담보', description: '간병·간호 관련 지급 조건을 기준별로 안내합니다.' },
        ],
      },
    ],
    PRODUCT_FIRE: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🏠', title: '건물 유형별 안내', description: '주택, 상가, 오피스텔 등 상황별로 다르게 봅니다.' },
          { icon: '🔥', title: '화재 손해 대비', description: '재산 피해에 대한 핵심 보장을 먼저 설명합니다.' },
          { icon: '🤝', title: '배상 위험 확인', description: '이웃 피해와 책임 범위도 함께 살펴봅니다.' },
        ],
      },
      {
        type: 'text',
        title: '화재보험, 이런 분께 필요합니다',
        content: '거주용 건물, 상가, 임대 건물 등 건물 용도와 관리 방식에 따라 꼭 확인해야 할 포인트가 달라질 수 있습니다.',
      },
    ],
  }

  return variantMap[category] || [
    {
      type: 'text',
      title: `${label}, 이런 분께 추천합니다`,
      content: `${label}의 주요 특징과 상담 전 확인해야 할 기준을 정리해드립니다.`,
    },
    {
      type: 'benefit-cards',
      title: '상담에서 이렇게 도와드립니다',
      items: [
        { icon: '✅', title: '핵심 보장부터', description: '가장 먼저 알아야 할 내용을 짧게 정리합니다.' },
        { icon: '✅', title: '비교 포인트', description: '상품 간 차이를 기준별로 설명합니다.' },
        { icon: '✅', title: '바로 문의', description: '궁금하실 때 폼에서 상담을 요청하실 수 있습니다.' },
      ],
    },
  ]
}

function getProductTemplate2Sections(category) {
  const variantMap = {
    PRODUCT_AUTO: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🚗', title: '핵심 담보 확인', description: '대인·대물·자차 등 꼭 필요한 항목부터 짚습니다.' },
          { icon: '⚡', title: '상담 접수', description: '필요한 정보를 남기면 상담을 이어갈 수 있습니다.' },
          { icon: '💬', title: '맞춤 상담', description: '차량과 운행 습관에 맞춰 안내해 드립니다.' },
        ],
      },
    ],
    PRODUCT_PENSION: [
      {
        type: 'stats',
        title: '연금 상담 전 확인 항목',
        items: [
          { label: '준비 목적', value: '노후 중심' },
          { label: '상담 방식', value: '1:1' },
          { label: '확인 항목', value: '수령 구조' },
        ],
      },
    ],
    PRODUCT_CARE: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🛏️', title: '장기 대비', description: '오랜 기간 이어질 수 있는 부담을 봅니다.' },
          { icon: '👨‍👩‍👧', title: '가족 부담 완화', description: '돌봄 공백과 비용 부담을 생각합니다.' },
          { icon: '📲', title: '상담 연결', description: '필요 시 바로 문의를 남길 수 있습니다.' },
        ],
      },
    ],
    PRODUCT_FIRE: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🏠', title: '건물 상황별 안내', description: '상황에 맞는 보장 포인트를 확인합니다.' },
          { icon: '🔥', title: '핵심 화재 보장', description: '재산 피해와 직접 연결되는 영역을 설명합니다.' },
          { icon: '🤝', title: '배상 위험 점검', description: '이웃 피해와 책임 범위도 함께 봅니다.' },
        ],
      },
    ],
  }

  return variantMap[category] || [
    {
      type: 'icon-grid',
      title: '',
      columns: 3,
      items: [
        { icon: '✓', title: '주요 기준 정리', description: '처음 검토하는 분도 기준을 잡을 수 있게 정리했습니다.' },
        { icon: '✓', title: '간편 신청', description: '필요한 정보만 남기면 상담으로 연결됩니다.' },
        { icon: '✓', title: '맞춤 안내', description: '고객님 상황에 맞는 상품 방향을 제안합니다.' },
      ],
    },
  ]
}

function getProductTemplate3Sections(category) {
  const variantMap = {
    PRODUCT_AUTO: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '📌', title: '핵심 보장 요약', description: '운전에 꼭 필요한 부분부터 차근차근 안내합니다.' },
          { icon: '🧾', title: '간단한 정보 입력', description: '기본 정보만으로 상담을 시작할 수 있습니다.' },
          { icon: '📲', title: '바로 문의', description: '궁금하신 순간 폼에서 상담을 요청하세요.' },
        ],
      },
      {
        type: 'benefit-cards',
        title: '자동차보험 상담 핵심 포인트',
        items: [
          { icon: '🚗', title: '내 차·운전 습관 반영', description: '주행 거리와 운전자 범위까지 함께 봅니다.' },
          { icon: '🛡️', title: '주요 담보 설명', description: '대인·대물·자차가 어떤 상황에서 쓰이는지 정리합니다.' },
          { icon: '⚖️', title: '조건 비교', description: '여러 상품의 차이를 한눈에 정리해 드립니다.' },
        ],
      },
      {
        type: 'process-steps',
        title: '상담 진행 방식',
        steps: [
          { number: 1, icon: '📝', title: '기본 정보 입력', description: '간단한 정보로 시작합니다.' },
          { number: 2, icon: '🔎', title: '상황 확인', description: '운전자와 차량 정보를 파악합니다.' },
          { number: 3, icon: '💬', title: '맞춤 안내', description: '필요한 방향으로 상담을 이어갑니다.' },
        ],
      },
    ],
    PRODUCT_PENSION: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '📌', title: '노후 목표 정하기', description: '언제, 어느 정도를 준비할지부터 함께 봅니다.' },
          { icon: '🧾', title: '납입·수령 구조', description: '납입 기간과 수령 방식의 차이를 설명합니다.' },
          { icon: '📲', title: '바로 상담', description: '궁금한 점을 정리한 뒤 1:1로 이어갑니다.' },
        ],
      },
      {
        type: 'benefit-cards',
        title: '연금보험 안내 포인트',
        items: [
          { icon: '🎯', title: '노후 준비 목적', description: '은퇴 후 생활비·여유 자금 등 목적을 먼저 맞춥니다.' },
          { icon: '📊', title: '언제·얼마나 받을지', description: '수령 시점과 방식을 내 상황에 맞게 짚습니다.' },
          { icon: '🕒', title: '오래 유지할 수 있는지', description: '납입 부담까지 고려해 장기 계획을 봅니다.' },
        ],
      },
      {
        type: 'process-steps',
        title: '연금 상담 흐름',
        steps: [
          { number: 1, icon: '📝', title: '목적 확인', description: '노후 준비 방향을 정리합니다.' },
          { number: 2, icon: '📊', title: '구조 설명', description: '납입과 수령 흐름을 설명합니다.' },
          { number: 3, icon: '💬', title: '맞춤 상담', description: '현재 상황에 맞는 방향을 제안합니다.' },
        ],
      },
    ],
    PRODUCT_CARE: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '📌', title: '왜 간병 대비가 필요한지', description: '장기 돌봄이 가족에게 미치는 부담을 함께 봅니다.' },
          { icon: '🧾', title: '꼭 확인할 담보', description: '간병비·간호 상태 등 핵심 조건을 정리합니다.' },
          { icon: '📲', title: '상담 요청', description: '궁금하신 내용을 남기시면 바로 연락드립니다.' },
        ],
      },
      {
        type: 'benefit-cards',
        title: '간병보험 안내 포인트',
        items: [
          { icon: '🛏️', title: '장기 비용', description: '간병이 길어질 때 드는 비용을 현실적으로 짚습니다.' },
          { icon: '👨‍👩‍👧', title: '가족의 시간·돈', description: '돌봄 공백과 경제 부담을 줄이는 방향을 봅니다.' },
          { icon: '📌', title: '중요 특약', description: '꼭 알아두어야 할 조건을 기준별로 안내합니다.' },
        ],
      },
      {
        type: 'text',
        title: '상담 후 이렇게 정리됩니다',
        content: '지금 꼭 필요한 보장인지, 오래 납입할 수 있는지, 가족에게 어떤 도움이 되는지까지 한 번에 짚어 드립니다.',
      },
    ],
    PRODUCT_FIRE: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🏠', title: '건물 유형별 맞춤 안내', description: '주택, 상가, 오피스텔 등 상황별로 확인합니다.' },
          { icon: '🔥', title: '화재 손해 핵심 보장', description: '재산 피해와 직접 연결되는 영역을 먼저 설명합니다.' },
          { icon: '📞', title: '언제든 상담 요청', description: '아래 폼에서 바로 문의를 남기실 수 있습니다.' },
        ],
      },
      {
        type: 'benefit-cards',
        title: '핵심 안내 포인트',
        items: [
          { icon: '✅', title: '건물/가재도구 보장', description: '상황에 맞는 보장 항목을 정리합니다.' },
          { icon: '✅', title: '배상책임 체크', description: '이웃 피해와 책임 범위도 함께 봅니다.' },
          { icon: '✅', title: '맞춤 비교', description: '필요 없는 특약은 줄이고 꼭 맞는 보장을 제안합니다.' },
        ],
      },
      {
        type: 'process-steps',
        title: '상담 진행 방식',
        steps: [
          { number: 1, icon: '📝', title: '상담 접수', description: '기본 정보를 남겨 주세요.' },
          { number: 2, icon: '🔎', title: '조건 확인', description: '건물 유형과 니즈를 파악합니다.' },
          { number: 3, icon: '💬', title: '맞춤 제안', description: '필요한 보장을 중심으로 안내합니다.' },
        ],
      },
    ],
  }

  return variantMap[category] || [
    {
      type: 'icon-grid',
      title: '',
      columns: 3,
      items: [
        { icon: '📌', title: '주요 기준 요약', description: '처음 검토하는 분도 기준을 잡을 수 있습니다.' },
        { icon: '🧾', title: '간단한 정보 입력', description: '필요한 정보만 남기면 상담으로 이어집니다.' },
        { icon: '📲', title: '바로 문의', description: '궁금하실 때 언제든 신청하실 수 있습니다.' },
      ],
    },
    {
      type: 'benefit-cards',
      title: '이렇게 도와드립니다',
      items: [
        { icon: '✅', title: '기준 중심 설명', description: '상품 조건을 판단 기준 중심으로 안내합니다.' },
        { icon: '✅', title: '상황별 검토', description: '고객님의 생활 단계에 맞춰 확인합니다.' },
        { icon: '✅', title: '편한 상담 신청', description: '이 페이지에서 바로 상담을 요청하실 수 있습니다.' },
      ],
    },
  ]
}

function getProductTemplate4Sections(category) {
  const label = getCategoryLabel(category)
  const variantMap = {
    PRODUCT_AUTO: [
      {
        type: 'stats',
        title: '자동차보험 상담 포인트',
        items: [
          { label: '핵심 비교', value: '3가지' },
          { label: '상담 방식', value: '1:1' },
          { label: '맞춤 설계', value: '차종별' },
          { label: '보장 점검', value: '1:1' },
        ],
      },
      {
        type: 'benefit-cards',
        title: '자동차보험, 이렇게 도와드립니다',
        items: [
          { icon: '🚗', title: '내 운전·차량 맞춤', description: '차종, 주행, 가족 공동 운전 여부까지 반영합니다.' },
          { icon: '🛡️', title: '핵심 보장부터', description: '대인·대물·자차 등 꼭 짚어야 할 항목을 먼저 설명합니다.' },
          { icon: '⚡', title: '비교 상담', description: '조건표의 차이를 기준별로 정리합니다.' },
        ],
      },
    ],
    PRODUCT_PENSION: [
      {
        type: 'stats',
        title: '연금보험 체크 포인트',
        items: [
          { label: '준비 목적', value: '노후 중심' },
          { label: '상담 방식', value: '1:1' },
          { label: '검토 기준', value: '수령 구조' },
          { label: '비교 포인트', value: '수령 구조' },
        ],
      },
      {
        type: 'process-steps',
        title: '연금보험 상담 흐름',
        steps: [
          { number: 1, icon: '🎯', title: '목적 확인', description: '노후 준비 목적을 먼저 정리합니다.' },
          { number: 2, icon: '📊', title: '구조 비교', description: '납입과 수령 구조의 차이를 설명합니다.' },
          { number: 3, icon: '💬', title: '맞춤 제안', description: '상황에 맞는 방향으로 상담을 이어갑니다.' },
        ],
      },
    ],
    PRODUCT_CARE: [
      {
        type: 'stats',
        title: '간병보험 확인 포인트',
        items: [
          { label: '대비 필요성', value: '장기 대비' },
          { label: '상담 방식', value: '1:1' },
          { label: '확인 항목', value: '지급 조건' },
          { label: '상담 형태', value: '1:1' },
        ],
      },
      {
        type: 'benefit-cards',
        title: '간병보험, 함께 보는 기준',
        items: [
          { icon: '🛏️', title: '장기 간병 대비', description: '오래 이어질 수 있는 비용을 현실적으로 짚습니다.' },
          { icon: '👨‍👩‍👧', title: '가족 부담', description: '돌봄과 비용을 가족이 감당하기 쉬운지 봅니다.' },
          { icon: '📌', title: '주요 특약', description: '꼭 확인할 담보를 기준별로 안내합니다.' },
        ],
      },
    ],
  }

  return variantMap[category] || [
    {
      type: 'stats',
      title: `${label} 안내 포인트`,
      items: [
        { label: '상담 방식', value: '1:1' },
        { label: '확인 항목', value: '주요 기준' },
        { label: '검토 기준', value: '상황별' },
        { label: '후속 안내', value: '필요 시' },
      ],
    },
    {
      type: 'benefit-cards',
      title: '상담 전 알아두시면 좋아요',
      items: [
        { icon: '✅', title: '핵심부터', description: '처음부터 중요한 내용만 골라 안내합니다.' },
        { icon: '✅', title: '간편 문의', description: '폼에서 바로 상담을 요청하실 수 있습니다.' },
        { icon: '✅', title: '맞춤 설명', description: '고객님 상황에 맞는 상품을 중심으로 설명합니다.' },
      ],
    },
  ]
}

function getProductTemplate5Sections(category) {
  const label = getCategoryLabel(category)
  const variantMap = {
    PRODUCT_COMPREHENSIVE: [
      {
        type: 'text',
        title: '종합보험, 이렇게 이해하시면 됩니다',
        content: '특약이 많아도 지금 생활에 꼭 필요한 보장부터 골라 보시면, 전체 구조가 훨씬 분명해집니다.',
      },
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🧩', title: '내 보장 구조', description: '여러 특약을 한눈에 정리해 드립니다.' },
          { icon: '📋', title: '필요한 보장만', description: '지금 꼭 챙겨야 할 부분부터 짚습니다.' },
          { icon: '💬', title: '1:1 상담', description: '궁금한 점을 물어보고 바로 상담하실 수 있습니다.' },
        ],
      },
    ],
    PRODUCT_WHOLE_LIFE: [
      {
        type: 'text',
        title: '종신보험 상담에서 먼저 보는 것',
        content: '보장 목적, 가족 보호 필요성, 보험료 지속 가능성 같은 핵심 기준부터 먼저 정리해드립니다.',
      },
      {
        type: 'comparison',
        title: '검토 전후 차이',
        before: {
          label: '검토 전',
          title: '목적과 필요 범위가 모호함',
          description: '막연히 필요하다고 느끼지만 어떤 기준으로 봐야 하는지 분명하지 않습니다.',
        },
        after: {
          label: '검토 후',
          title: '준비 목적과 선택 기준이 명확해짐',
          description: '가족 보호 목적과 현재 상황 기준으로 상담 방향이 정리됩니다.',
        },
      },
    ],
    PRODUCT_FIRE: [
      {
        type: 'text',
        title: '화재보험에서 꼭 먼저 보는 부분',
        content: '건물 유형, 사용 목적, 배상 위험 범위를 먼저 이해하면 화재보험의 주요 기준을 분명하게 파악할 수 있습니다.',
      },
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🏠', title: '건물 유형별 확인', description: '주택, 상가, 오피스텔 등 상황별로 다르게 봅니다.' },
          { icon: '🔥', title: '재산 손해 대비', description: '화재로 인한 직접 피해를 먼저 점검합니다.' },
          { icon: '🤝', title: '배상 위험 확인', description: '이웃 피해나 책임 범위까지 함께 생각합니다.' },
        ],
      },
    ],
  }

  return variantMap[category] || [
    {
      type: 'text',
      title: '상담 전 확인할 상품 기준',
      content: `${label}의 필요성과 핵심 특징을 먼저 확인하고 지금 필요한 상담으로 바로 이어가실 수 있습니다.`,
    },
    {
      type: 'icon-grid',
      title: '',
      columns: 3,
      items: [
        { icon: '📌', title: '주요 특징', description: '꼭 알아야 할 내용을 먼저 전달합니다.' },
        { icon: '🧾', title: '간편 문의', description: '입력 부담을 줄인 상담 신청 구조입니다.' },
        { icon: '💬', title: '맞춤 상담', description: '상황에 맞는 설명으로 연결됩니다.' },
      ],
    },
  ]
}

function getProductTheme(presetKey, category) {
  const themeMap = {
    PRODUCT_AUTO: {
      default: { heroBackgroundColor: '#eff6ff', heroTextColor: '#0f172a', heroSubtitleColor: '#2563eb' },
      'clean-form': { heroBackgroundColor: '#eff6ff', heroTextColor: '#0f172a', heroSubtitleColor: '#2563eb', formBorderColor: '#2563eb', formBorderWidth: 3 },
      'hanwha-sections': { heroBackgroundColor: '#dbeafe', heroTextColor: '#0f172a', heroSubtitleColor: '#1d4ed8', formBorderColor: '#2563eb', formBorderWidth: 3, highlightsBackgroundColor: '#eff6ff', recommendedTitle: '추천상품' },
      'basic-template-4': { heroBackgroundColor: '#dbeafe', heroTextColor: '#0f172a', heroSubtitleColor: '#1d4ed8', formBorderColor: '#2563eb', formBorderWidth: 3, ctaBandBackgroundColor: '#bfdbfe' },
      'basic-template-5': { heroBackgroundColor: '#0f172a', heroTextColor: '#ffffff', heroSubtitleColor: '#bfdbfe', formBorderColor: '#1d4ed8', formBorderWidth: 2, bodyBackgroundColor: '#f8fafc' },
    },
    PRODUCT_PENSION: {
      default: { heroBackgroundColor: '#fff7ed', heroTextColor: '#7c2d12', heroSubtitleColor: '#c2410c' },
      'clean-form': { heroBackgroundColor: '#fff7ed', heroTextColor: '#7c2d12', heroSubtitleColor: '#ea580c', formBorderColor: '#f97316', formBorderWidth: 3 },
      'hanwha-sections': { heroBackgroundColor: '#ffedd5', heroTextColor: '#7c2d12', heroSubtitleColor: '#c2410c', formBorderColor: '#ea580c', formBorderWidth: 3, highlightsBackgroundColor: '#fff7ed', recommendedTitle: '추천상품' },
      'basic-template-4': { heroBackgroundColor: '#ffedd5', heroTextColor: '#7c2d12', heroSubtitleColor: '#c2410c', formBorderColor: '#ea580c', formBorderWidth: 3, ctaBandBackgroundColor: '#fed7aa' },
      'basic-template-5': { heroBackgroundColor: '#7c2d12', heroTextColor: '#ffffff', heroSubtitleColor: '#fdba74', formBorderColor: '#ea580c', formBorderWidth: 2, bodyBackgroundColor: '#fff7ed' },
    },
    PRODUCT_CARE: {
      default: { heroBackgroundColor: '#fdf2f8', heroTextColor: '#831843', heroSubtitleColor: '#be185d' },
      'clean-form': { heroBackgroundColor: '#fdf2f8', heroTextColor: '#831843', heroSubtitleColor: '#db2777', formBorderColor: '#ec4899', formBorderWidth: 3 },
      'hanwha-sections': { heroBackgroundColor: '#fce7f3', heroTextColor: '#831843', heroSubtitleColor: '#be185d', formBorderColor: '#db2777', formBorderWidth: 3, highlightsBackgroundColor: '#fdf2f8', recommendedTitle: '추천상품' },
      'basic-template-4': { heroBackgroundColor: '#fce7f3', heroTextColor: '#831843', heroSubtitleColor: '#be185d', formBorderColor: '#db2777', formBorderWidth: 3, ctaBandBackgroundColor: '#fbcfe8' },
      'basic-template-5': { heroBackgroundColor: '#831843', heroTextColor: '#ffffff', heroSubtitleColor: '#f9a8d4', formBorderColor: '#db2777', formBorderWidth: 2, bodyBackgroundColor: '#fdf2f8' },
    },
    PRODUCT_FIRE: {
      default: { heroBackgroundColor: '#fff7ed', heroTextColor: '#7c2d12', heroSubtitleColor: '#ea580c' },
      'clean-form': { heroBackgroundColor: '#ffebec', heroTextColor: '#1e293b', heroSubtitleColor: '#dc2626', formBorderColor: '#ff7b1b', formBorderWidth: 4 },
      'hanwha-sections': { heroBackgroundColor: '#dff6f1', heroTextColor: '#111827', heroSubtitleColor: '#0f766e', formBorderColor: '#ff7b1b', formBorderWidth: 3, highlightsBackgroundColor: '#f8fafc', recommendedTitle: '추천상품' },
      'basic-template-4': { heroBackgroundColor: '#ffedd5', heroTextColor: '#7c2d12', heroSubtitleColor: '#c2410c', formBorderColor: '#ea580c', formBorderWidth: 3, ctaBandBackgroundColor: '#fed7aa' },
      'basic-template-5': { heroBackgroundColor: '#7c2d12', heroTextColor: '#ffffff', heroSubtitleColor: '#fdba74', formBorderColor: '#ea580c', formBorderWidth: 2, bodyBackgroundColor: '#fff7ed' },
    },
    PRODUCT_WHOLE_LIFE: {
      default: { heroBackgroundColor: '#f8fafc', heroTextColor: '#111827', heroSubtitleColor: '#475569' },
      'clean-form': { heroBackgroundColor: '#f8fafc', heroTextColor: '#111827', heroSubtitleColor: '#475569', formBorderColor: '#334155', formBorderWidth: 3 },
      'hanwha-sections': { heroBackgroundColor: '#e2e8f0', heroTextColor: '#111827', heroSubtitleColor: '#334155', formBorderColor: '#334155', formBorderWidth: 3, highlightsBackgroundColor: '#f8fafc', recommendedTitle: '추천상품' },
      'basic-template-4': { heroBackgroundColor: '#e2e8f0', heroTextColor: '#111827', heroSubtitleColor: '#334155', formBorderColor: '#334155', formBorderWidth: 3, ctaBandBackgroundColor: '#cbd5e1' },
      'basic-template-5': { heroBackgroundColor: '#111827', heroTextColor: '#ffffff', heroSubtitleColor: '#cbd5e1', formBorderColor: '#334155', formBorderWidth: 2, bodyBackgroundColor: '#f8fafc' },
    },
  }
  const direct = themeMap[category]?.[presetKey] || null
  if (direct) return direct
  if (presetKey === 'lead-gen-fullbleed') {
    const base = themeMap[category]?.['hanwha-sections']
    if (base) {
      return {
        ...base,
        heroBandBackgroundColor: '#ECEAFF',
        detailStripBackgroundColor: '#F7F7F7',
        formBorderColor: '#f47321',
        formBorderWidth: 2,
      }
    }
    return {
      heroBandBackgroundColor: '#ECEAFF',
      detailStripBackgroundColor: '#F7F7F7',
      formBorderColor: '#f47321',
      formBorderWidth: 2,
      highlightsBackgroundColor: '#f8fafc',
      recommendedTitle: '추천상품',
    }
  }
  return null
}

export function createInsuranceProductPreset(category, copy, presetKey = 'default') {
  const resolvedCopy = copy || {
    heroTitle: `${getCategoryLabel(category)} 안내`,
    heroSubtitle: `${getCategoryLabel(category)}의 주요 기준과 상담 전 확인할 항목을 안내합니다.`,
    formTitle: `${getCategoryLabel(category)} 상담 신청`,
  }

  if (presetKey === 'clean-form') {
    return {
      key: `${String(category || '').toLowerCase()}-clean-form`,
      category,
      name: `${getCategoryLabel(category)} 기본 템플릿 2 - 간편 문의형`,
      heroTitle: resolvedCopy.heroTitle,
      heroSubtitle: resolvedCopy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage(category),
      formTitle: resolvedCopy.formTitle,
      contentSections: getProductTemplate2Sections(category),
      formFields: createCategoryLandingDefaultFormFields(),
      surveyCustomFields: buildDefaultSurveyCustomFields(category),
      customConfig: {
        templateStyle: 'clean-form',
        heroBackgroundColor: '#f8fafc',
        heroTextColor: '#0f172a',
        heroSubtitleColor: '#2563eb',
        formBorderColor: '#2563eb',
        formBorderWidth: 3,
        ...(getProductTheme('clean-form', category) || {}),
      },
    }
  }

  if (presetKey === 'hanwha-sections') {
    return {
      key: `${String(category || '').toLowerCase()}-hanwha-sections`,
      category,
      name: `${getCategoryLabel(category)} 기본 템플릿 3 - 설명형`,
      heroTitle: resolvedCopy.heroTitle,
      heroSubtitle: resolvedCopy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage(category),
      formTitle: resolvedCopy.formTitle,
      contentSections: getProductTemplate3Sections(category),
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: buildDefaultSurveyCustomFields(category),
      customConfig: {
        templateStyle: 'hanwha-sections',
        heroBackgroundColor: '#e8f7f3',
        heroTextColor: '#111827',
        heroSubtitleColor: '#0f766e',
        formBorderColor: '#ff7b1b',
        formBorderWidth: 3,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
        ...(getProductTheme('hanwha-sections', category) || {}),
      },
    }
  }

  if (presetKey === 'lead-gen-fullbleed') {
    return {
      key: `${String(category || '').toLowerCase()}-lead-gen-fullbleed`,
      category,
      name: `${getCategoryLabel(category)} 기본 템플릿 6 - 풀블리드 전환형`,
      heroTitle: resolvedCopy.heroTitle,
      heroSubtitle: resolvedCopy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage(category),
      formTitle: resolvedCopy.formTitle,
      contentSections: getProductTemplate3Sections(category),
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: buildDefaultSurveyCustomFields(category),
      customConfig: {
        templateStyle: leadGenFullbleedTemplateStyleForCategory(category),
        heroBandBackgroundColor: '#ECEAFF',
        detailStripBackgroundColor: '#F7F7F7',
        heroDetailImageFileId: '',
        formBorderColor: '#f47321',
        formBorderWidth: 2,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
        ...(getProductTheme('lead-gen-fullbleed', category) || {}),
      },
    }
  }

  if (presetKey === 'basic-template-4') {
    return {
      key: `${String(category || '').toLowerCase()}-basic-template-4`,
      category,
      name: `${getCategoryLabel(category)} 기본 템플릿 4 - CTA 강조형`,
      heroTitle: resolvedCopy.heroTitle,
      heroSubtitle: resolvedCopy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage(category),
      formTitle: resolvedCopy.formTitle,
      contentSections: getProductTemplate4Sections(category),
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: buildDefaultSurveyCustomFields(category),
      customConfig: {
        templateStyle: 'basic-template-4',
        heroBackgroundColor: '#eef4ff',
        heroTextColor: '#0f172a',
        heroSubtitleColor: '#334155',
        formBorderColor: '#2563eb',
        formBorderWidth: 3,
        ctaBandBackgroundColor: '#dbeafe',
        ...(getProductTheme('basic-template-4', category) || {}),
      },
    }
  }

  if (presetKey === 'basic-template-5') {
    return {
      key: `${String(category || '').toLowerCase()}-basic-template-5`,
      category,
      name: `${getCategoryLabel(category)} 기본 템플릿 5 - 프리미엄 상담형`,
      heroTitle: resolvedCopy.heroTitle,
      heroSubtitle: resolvedCopy.heroSubtitle,
      heroImageFileId: getCategoryLandingHeroImage(category),
      formTitle: resolvedCopy.formTitle,
      contentSections: getProductTemplate5Sections(category),
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: buildDefaultSurveyCustomFields(category),
      customConfig: {
        templateStyle: 'basic-template-5',
        heroBackgroundColor: '#111827',
        heroTextColor: '#ffffff',
        heroSubtitleColor: '#cbd5e1',
        formBorderColor: '#0f172a',
        formBorderWidth: 2,
        bodyBackgroundColor: '#f8fafc',
        ...(getProductTheme('basic-template-5', category) || {}),
      },
    }
  }

  return {
    key: `${String(category || '').toLowerCase()}-default`,
    category,
    name: `${getCategoryLabel(category)} 기본 템플릿 1 - 일반형`,
    heroTitle: resolvedCopy.heroTitle,
    heroSubtitle: resolvedCopy.heroSubtitle,
    heroImageFileId: getCategoryLandingHeroImage(category),
    formTitle: resolvedCopy.formTitle,
      contentSections: getProductTemplate1Sections(category),
    formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
    surveyCustomFields: buildDefaultSurveyCustomFields(category),
    customConfig: {
      templateStyle: 'default',
        heroBackgroundColor: '#f8fafc',
        heroTextColor: '#0f172a',
        heroSubtitleColor: '#475569',
        ...(getProductTheme('default', category) || {}),
    },
  }
}
